import React, { useEffect, useState } from 'react';
import Style from './Footer.module.scss';
import { Reveal } from '../ui/Reveal';
import Magnetic from '../ui/Magnetic';
import { info } from '../../info/Info';
import { ArrowUpRight, MailIcon, socialIconMap } from '../ui/Icons';

function LocalTime() {
    const [time, setTime] = useState('');
    useEffect(() => {
        const update = () => setTime(
            new Date().toLocaleTimeString('en-US', {
                hour: '2-digit', minute: '2-digit', timeZone: 'America/Los_Angeles',
            })
        );
        update();
        const id = setInterval(update, 30000);
        return () => clearInterval(id);
    }, []);
    return <span>{time} PT</span>;
}

export default function Footer({ innerRef, onOpenContact, onOpenResume }) {
    return (
        <footer id="contact" ref={innerRef} className={Style.footer}>
            <div className={Style.inner}>
                <Reveal>
                    <p className={Style.request}>
                        <span className={Style.method}>POST</span> /contact
                        <span className={Style.arrow}>→</span>
                        <span className={Style.response}>202 Accepted</span>
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <h2 className={Style.headline}>
                        Let's build something<br />
                        <em>that ships.</em>
                    </h2>
                </Reveal>

                <Reveal delay={0.2}>
                    <div className={Style.ctas}>
                        <div className={Style.btnGroup}>
                            <Magnetic strength={0.25}>
                                <button
                                    type="button"
                                    className={Style.mailBtn}
                                    onClick={onOpenContact}
                                >
                                    <MailIcon size={15} /> send a message
                                </button>
                            </Magnetic>
                            <Magnetic strength={0.25}>
                                <a
                                    href={info.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={Style.ghostBtn}
                                >
                                    connect on linkedin <ArrowUpRight size={14} />
                                </a>
                            </Magnetic>
                        </div>
                        <div className={Style.socials}>
                            {info.socials.map((social) => {
                                const Icon = socialIconMap[social.icon];
                                return (
                                    <a
                                        key={social.label}
                                        href={social.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={Style.socialLink}
                                    >
                                        <Icon size={15} /> {social.label.toLowerCase()} <ArrowUpRight size={11} />
                                    </a>
                                );
                            })}
                            <button
                                type="button"
                                onClick={onOpenResume}
                                className={Style.socialLink}
                            >
                                request resume <ArrowUpRight size={11} />
                            </button>
                        </div>
                    </div>
                </Reveal>

                <div className={Style.meta}>
                    <span>© 2026 {info.firstName} {info.lastName}</span>
                    <span>{info.location.toLowerCase()} · <LocalTime /></span>
                    <span className={Style.metaEnd}>designed & built by me · intro film by AI</span>
                </div>
            </div>
        </footer>
    );
}
